import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export interface VaccineMethod {
  id: string;
  emoji: string;
}

interface VaccineMethodPickerProps {
  methods: VaccineMethod[];
  selectedMethod: string | null;
  onSelect: (methodId: string) => void;
}

export const VaccineMethodPicker: React.FC<VaccineMethodPickerProps> = ({
  methods,
  selectedMethod,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="p-4">
      <h3 className="text-lg font-medium mb-4 text-center">
        {t('cbs.vaccination.howGiven')}
      </h3>
      <div className="grid grid-cols-4 gap-2">
        {methods.map((method) => (
          <button
            key={method.id}
            onClick={() => onSelect(method.id)}
            className={cn(
              'flex flex-col items-center p-4 rounded-xl border-2 transition-all',
              selectedMethod === method.id
                ? 'border-primary bg-primary/10 scale-105'
                : 'border-border hover:border-primary/50'
            )}
          >
            <span className="text-4xl mb-1">{method.emoji}</span>
            <span className="text-xs font-medium text-center">
              {t(`cbs.vaccination.methods.${method.id}`)}
            </span>
          </button>
        ))}
      </div>
    </Card>
  );
};

export default VaccineMethodPicker;
